import { render, staticRenderFns } from "./veStuCheckJudgerEdit.vue?vue&type=template&id=7e839531&scoped=true"
import script from "./veStuCheckJudgerEdit.vue?vue&type=script&lang=js"
export * from "./veStuCheckJudgerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e839531",
  null
  
)

export default component.exports